import api from '../api'


export const getFile = async ({ file }, params = {}) => api.get(`v1/uploads/document/${ file }`, {
  responseType:'blob',
  params
})
